import { render } from "./ProformaInvoicesView.vue?vue&type=template&id=2dde4f13"
import script from "./ProformaInvoicesView.vue?vue&type=script&lang=js"
export * from "./ProformaInvoicesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__